import React from "react";
import { Link } from "react-router-dom";
import { ClipboardList, User, ArrowUpRight } from "lucide-react";
import { BRAND } from "../lib/constants";

function PortalTile({ to, eyebrow, title, description, icon: Icon, accent, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group relative flex flex-col bg-white border border-[var(--tir-ink)] hover:border-[var(--tir-burgundy)] transition-colors overflow-hidden min-h-[420px]"
    >
      <div className="absolute top-0 left-0 h-1 w-full" style={{ backgroundColor: accent }} />
      <div className="p-8 lg:p-12 flex-1 flex flex-col">
        <div className="flex items-start justify-between mb-8">
          <div
            className="h-16 w-16 border border-[var(--tir-ink)] flex items-center justify-center group-hover:bg-[var(--tir-burgundy)] group-hover:border-[var(--tir-burgundy)] group-hover:text-white transition-colors"
            style={{ color: accent }}
          >
            <Icon size={28} strokeWidth={1.3} />
          </div>
          <ArrowUpRight
            size={32}
            className="text-[var(--tir-muted)] group-hover:text-[var(--tir-burgundy)] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
          />
        </div>
        <div
          className="text-[11px] tracking-[0.32em] uppercase font-semibold mb-4"
          style={{ color: accent }}
        >
          {eyebrow}
        </div>
        <div className="font-serif-display text-5xl lg:text-6xl text-[var(--tir-ink)] leading-[1.05] mb-5">
          {title}
        </div>
        <p className="text-base text-[var(--tir-muted)] leading-relaxed">
          {description}
        </p>
      </div>
    </Link>
  );
}

export default function PortalChooserPage() {
  return (
    <div className="min-h-screen bg-[var(--tir-ivory)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 lg:py-20">
        <div className="text-center mb-14 lg:mb-20">
          <div className="font-eyebrow text-[11px] tracking-[0.34em] uppercase font-semibold text-[var(--tir-burgundy)] mb-3">
            {BRAND.name || "The Intuitive Runner"}
          </div>
          <h1 className="font-serif-display text-5xl lg:text-7xl text-[var(--tir-ink)] leading-[0.95] mb-5">
            Welcome.
          </h1>
          <p className="text-base lg:text-lg text-[var(--tir-muted)] max-w-2xl mx-auto leading-relaxed">
            Choose your portal — coaches manage athletes, programs, and lactate testing here;
            athletes view their training, log completions, and stay in sync.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          <PortalTile
            to="/athlete/login"
            eyebrow="For athletes"
            title="Athlete Portal"
            description="View your training, mark workouts complete, leave notes for your coach, and check your VDOT and zones."
            icon={User}
            accent="#1F3A5F"
            testId="portal-chooser-athlete"
          />
          <PortalTile
            to="/login"
            eyebrow="For coaches"
            title="Coach's Hub"
            description="Manage athletes, build training programs, run lactate tests, and review activity across your roster."
            icon={ClipboardList}
            accent="#7A1F2B"
            testId="portal-chooser-coach"
          />
        </div>

        <div className="mt-16 text-center">
          <p className="font-eyebrow text-xs tracking-[0.22em] uppercase text-[var(--tir-muted)]">
            New athlete? Check your email for an invite link from your coach.
          </p>
        </div>
      </div>
    </div>
  );
}
